<template>
  <div>
    <div class="card data-table mb-5 mb-xl-10">
      <div class="card-header py-3">
        <div class="body-function">
          <div class="col-md-6">
            <el-button type="primary" plain outline native-type="submit" @click="handleOpenAdd" data-bs-toggle="modal"
              data-bs-target="#modal_banner">
              <span class="btn-inner--icon"><i class="fas fa-plus"></i></span>
              <span class="btn-inner--text">&nbsp;Thêm banner</span>
            </el-button>
          </div>
          <!-- <div class="col-md-6" style="text-align:right">
                <el-button plain icon="el-icon-refresh"  style="margin-right:30px" title="Đồng bộ" type="warning" @click=""
                  v-loading.fullscreen.lock="isLoading"></el-button>
              </div> -->
        </div>
      </div>
      <div class="tbl px-2 mt-3 ">
        <el-row :gutter="10" class="d-flex justify-content-center ">
          <el-col :xs="12" :sm="8" :md="6" :lg="4" :xl="4" v-for="item in tableData.content"
            class="d-flex justify-content-center align-items-center h-150px mb-3">
            <div :style="'background: url(' + baseUrl + item.cUrl + '); background-size:cover'"
              class="w-100 h-100 border">
              <div class="bannerActions w-100 h-100 d-flex justify-content-center align-items-center">
                <i class="el-icon-search text-hover-primary text-white fs-2 fw-bold cursor-pointer p-2 preview"
                  @click="handlePictureCardPreview({ ...item, url: baseUrl + item.cUrl })"></i>
                <i data-bs-toggle="modal" data-bs-target="#modal_banner" @click="handleOpenEdit(item)"
                  class="el-icon-edit text-hover-primary text-white fs-2 fw-bold cursor-pointer p-2 edit"></i>
                <i class="el-icon-delete text-hover-danger text-white fs-2 fw-bold cursor-pointer p-2 delete"
                  @click="handleDelete(item)"></i>
              </div>
            </div>
          </el-col>
        </el-row>
      </div>
      <div class="col-12 py-2 pagination" style="justify-content: end">
        <el-pagination @size-change="handleChangePageSize" @current-change="handleChangePageNum"
          :current-page.sync="tableData.pageNum" :page-sizes="[6, 12, 24, 26, 48]" :page-size="tableData.pageSize"
          layout="total, sizes, prev, pager, next, jumper" :total="tableData.totalSize">
        </el-pagination>
      </div>
    </div>

    <div class="modal fade" id="modal_banner" ref="bannerModalRef" tabindex="-1" aria-hidden="true">
      <div class="modal-dialog modal-dialog-centered mw-550px">
        <div class="modal-content">
          <!--begin::Modal header-->
          <div class="modal-header" id="modal_banner_header">
            <!--begin::Modal title-->
            <h2 class="fw-bolder">{{ !operation ? "Thêm banner" : "Cập nhật banner" }}</h2>
            <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" @click="handleClose">
              <span class="svg-icon svg-icon-1">
                <inline-svg src="/media/icons/duotune/arrows/arr061.svg" />
              </span>
            </div>
            <!--end::Close-->
          </div>
          <!--end::Modal header-->
          <div class="modal-body">
            <el-form :model="formData" :rules="rules" ref="formData" class="d-flex flex-column" label-width="0">
              <el-form-item label="" prop="bannerFile">
                <el-upload action="#" list-type="picture-card" :auto-upload="false" placeholder="Chọn banner"  accept="image/*"
                  ref="upload" :file-list="bannerFile" :on-preview="handlePictureCardPreview"
                  :on-change="handleChangeFile" :on-remove="handleRemoveFile" class="w-100 d-flex justify-content-center">
                  <div class="d-flex align-items-center justify-content-center w-100 h-100">
                    <i class="el-icon-plus" v-if="bannerFile.length == 0"></i>
                    <i class="el-icon-refresh" v-if="bannerFile.length > 0"></i>
                  </div>
                </el-upload>
              </el-form-item>
            </el-form>
          </div>
          <div class="modal-footer">
            <div class="btn-group">
              <el-button v-if="!operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Thêm</el-button>
              <el-button v-if="operation" type="primary" v-loading.fullscreen.lock="isLoading"
                @click="handleSave">Lưu</el-button>
              <el-button type="danger" @click="handleClose">Thoát</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-model="dialogVisible" class="bg-transparent w-auto shadow-none">
      <img class="mh-500px mw-1000px" :src="dialogImageUrl" alt="Preview Image" />
    </el-dialog>
  </div>
</template>
<script>
import { Banners } from "@/store/enums/StoreEnums";
import moment from "moment";
import { useStore } from "vuex";
import { hideModal } from "@/core/helpers/dom";
import { baseUrl } from "@/utils/global";
import { ElMessage } from "element-plus";
export default {
  name: 'banner',
  data() {
    return {
      search: {
        nTinhTrang: "-1",
        cTen: "",
      },
      pageRequest: {
        columnFilters: {},
        pageSize: 30,
        pageNum: 1
      },
      formData: {
        cUrl: "",
        bannerFile: []
      },
      rules: {
        bannerFile: [
          {
            required: true, message: 'Xin vui lòng chọn banner', trigger: 'change', validator: (rule, value, callback) => {
              if (this.bannerFile.length === 0) {
                callback(new Error('Xin vui lòng chọn banner'));
              } else {
                callback();
              }
            }
          },
        ],
      },
      tableData: {
        content: []
      },
      isLoading: false,
      modalVisible: false,
      operation: false,
      isSearchLoading: false,
      bannerFile: [],
      size: "small",
      store: useStore(),
      baseUrl: baseUrl,
      dialogVisible: false,
      dialogImageUrl: ""
    }
  },
  watch: {
    modalVisible() {
      if (!this.modalVisible) {
        this.bannerFile = []
      }
    }
  },
  methods: {
    handleChangePageNum(val) {
      this.pageRequest.pageNum = val
      this.handleFindPage()
    },
    handleChangePageSize(val) {
      this.pageRequest.pageSize = val
      this.handleFindPage()
    },
    handleOpenAdd() {
      this.$refs.formData.resetFields()
      this.modalVisible = true
      this.operation = false
      this.formData = {}
    },
    handleOpenEdit(val) {
      this.$refs.formData.resetFields()
      this.modalVisible = true
      this.operation = true
      this.formData = Object.assign({}, val)
      if (val.cUrl) {
        this.addImageFromURL(baseUrl + val.cUrl)
      }
    },
    handleClose() {
      this.modalVisible = false
      hideModal(this.$refs.bannerModalRef)
    },
    handleDelete(val) {
      this.$confirm("Bạn có muốn xóa banner này không?", "Xác nhận", {
        confirmButtonText: "Xác nhận",
        cancelButtonText: "Hủy",
        type: "warning",
      })
        .then(() => {
          this.store.dispatch(Banners.deleteBannersById, val.nMaBienHieu).then(res => {
            if (res.code == 200) {
              ElMessage({ message: "Xóa banner thành công", type: "success" });
              this.handleFindPage()
            } else {
              ElMessage({ message: res.msg, type: "error" });
            }
          }).catch((error) => {
            ElMessage({ message: "Xóa banner thất bại", type: "error" });
          })
        })
    },
    handleFindPage() {
      this.store.dispatch(Banners.findPageBanners, { pageNum: this.pageRequest.pageNum, pageSize: this.pageRequest.pageSize }).then(res => {
        if (res.code == 200) {
          this.tableData = res.data
        }
      })
    },
    async handleChangeFile(file, bannerFile) {
      this.bannerFile = [file]
      this.formData.bannerFile = this.bannerFile
      this.formData.cUrl = file.name
    },
    handleRemoveFile(file, bannerFile) {
      this.bannerFile = []
      this.formData.bannerFile = this.bannerFile
      this.formData.cUrl = null
    },
    addImageFromURL(url) {
      fetch(url)
        .then(res => res.blob())
        .then(blob => {
          const file = new File([blob], "image.jpg", { type: blob.type });
          this.bannerFile.push({
            name: file.name,
            url: URL.createObjectURL(file),
            status: 'success',
            uid: Date.now(),
            raw: file
          });
        });
    },
    momentDate(val) {
      return val ? moment(val).format("DD/MM/YYYY") : ""
    },
    handleSave() {
      this.$refs.formData.validate((valid) => {
        const data = {
          cTen: this.formData.cTen,
          nTinhTrang: 1,
          cUrl: this.formData.cUrl,
        }

        const formData = new FormData();

        if (this.bannerFile.length > 0) {
          this.bannerFile.forEach(e => {
            if (e.status === "ready") formData.append('image', e.raw);
          })
        }
        if (this.operation) {
          data.id = this.formData.nMaBienHieu
          formData.append('bannerRequest', new Blob([JSON.stringify(data)], { type: "application/json" }));
          this.store.dispatch(Banners.updateBanners, { id: data.id, data: formData }).then(res => {
            if (res.code == 200) {
              ElMessage({ message: "Cập nhật banner thành công", type: "success" })
              this.handleFindPage()
              this.handleClose()
            } else {
              ElMessage({ message: "Cập nhật banner thất bại", type: "error" })
            }
          }).catch(() => {
            ElMessage({ message: "Cập nhật banner thất bại", type: "error" })
          })
        } else {
          formData.append('bannerRequest', new Blob([JSON.stringify(data)], { type: "application/json" }));
          this.store.dispatch(Banners.saveBanners, formData).then(res => {
            if (res.code == 200) {
              ElMessage({ message: "Lưu banner thành công", type: "success" })
              this.handleFindPage()
              this.handleClose()
            } else {
              ElMessage({ message: "Lưu banner thất bại", type: "error" })
            }
          }).catch(() => {
            ElMessage({ message: "Lưu banner thất bại", type: "error" })
          })
        }
      })


    },
    handlePictureCardPreview(val) {
      this.dialogImageUrl = val.url
      this.dialogVisible = true
    },
  },
  mounted() {
    this.handleFindPage()
  }
};
</script>
<style lang="scss" scoped>
.bannerActions {
  .preview {
    display: none;
    transition: all 0.3s ease;
  }

  .edit {
    display: none;
    transition: all 0.3s ease;
  }

  .delete {
    display: none;
    transition: all 0.3s ease;
  }

  transition: all 0.3s ease;
}

.bannerActions:hover {
  .preview {
    display: block;
  }

  .edit {
    display: block;
  }

  .delete {
    display: block;
  }

  background-color: rgba(0, 0, 0, 0.4);
}
</style>